import React, { memo } from "react";
import { Highlight, HStack, Text } from "@chakra-ui/react";
import colors from "app/colors";
import { CALLOUT_KEY, HASH_KEY } from "modules/utils/Constants";

export interface ISuggestionDataItem {
  id: string;
  display: string;
  subDisplay?: string;
  isExternal?: boolean;
}

interface IProps {
  suggestionDataItem: ISuggestionDataItem;
  search: string;
}

const TextHighlighter = memo<IProps>(({ suggestionDataItem, search }) => (
  <HStack color={colors.blue} spacing={0}>
    <Highlight
      query={[
        // Cannot have nested highlights, but we can have multiple highlights, so we need to order from most detailed to least
        `${CALLOUT_KEY}${search}`,
        `${HASH_KEY}${search}`,
        search,
        CALLOUT_KEY,
        HASH_KEY,
      ]}
      styles={{
        fontWeight: 700,
        fontSize: 14,
        color: colors.blue,
        margin: "0 !important",
      }}
    >
      {suggestionDataItem.display || ""}
    </Highlight>
    {suggestionDataItem.subDisplay && (
      <Text pl={1} color={colors.gray50} fontSize={12}>
        {suggestionDataItem.subDisplay}
      </Text>
    )}
  </HStack>
));

export default memo(TextHighlighter);
